import React from "react";
import { languages } from "../../../constants/languages";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import ListSubheader from "@material-ui/core/ListSubheader";

export default class WidthMenu extends React.Component {
  render() {
    return (
      <FormControl size="small" variant="outlined" style={{ marginRight: 5 }}>
        <Select
          style={{ height: 30 }}
          value={this.props.value}
          onChange={this.props.handleWidthChange}
          inputProps={this.props.inputProps}
          disabled={this.props.disabled}
        >
          <ListSubheader>{languages.present.width}</ListSubheader>
          {this.props.enable25width && <MenuItem value="4">25%</MenuItem>}
          <MenuItem value="0" disabled={this.props.onlyFullWidth}>
            33%
          </MenuItem>
          <MenuItem value="1" disabled={this.props.onlyFullWidth}>
            50%
          </MenuItem>
          <MenuItem value="2" disabled={this.props.onlyFullWidth}>
            66%
          </MenuItem>
          <MenuItem value="3">100%</MenuItem>
        </Select>
      </FormControl>
    );
  }
}
